/**
 * Hide collection sale tag / savings when not all variants are on sale.
 * Covers theme markup and app-injected badges (e.g. Sezerium).
 */
function hidePartialSaleCollectionBadges(root) {
  const scope = root || document;
  scope.querySelectorAll('[data-all-variants-on-sale="false"]').forEach((card) => {
    const container = card.closest('.grid-item') || card;
    container
      .querySelectorAll(
        '.grid-product__tag--sale, .grid-product__price--savings, .grid-product__price--original, .sezerium-save-badge'
      )
      .forEach((el) => {
        el.style.display = 'none';
        el.setAttribute('hidden', '');
      });
  });
}

function initCollectionSaleBadges() {
  hidePartialSaleCollectionBadges();

  const grid = document.querySelector('.collection-grid, #CollectionAjaxContent, .globo-list');
  if (!grid || grid.dataset.partialSaleObserver) return;
  grid.dataset.partialSaleObserver = 'true';

  const observer = new MutationObserver(() => hidePartialSaleCollectionBadges(grid));
  observer.observe(grid, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionSaleBadges);
} else {
  initCollectionSaleBadges();
}

document.addEventListener('shopify:section:load', initCollectionSaleBadges);
